//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { billRecordApi } from '@/api/enterprise';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  name: 'viewDetails',
  components: {
    ElImageViewer: ElImageViewer
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      tabIndex: '1',
      imageUrl: '',
      delData: {},
      recordList: [],
      isImage: false,
      srcList: []
    };
  },
  computed: {},
  watch: {
    formData: {
      handler: function handler(nVal, oVal) {
        this.delData = nVal.data;
        if (JSON.stringify(this.delData.attachs) !== '[]') {
          this.imageUrl = this.delData.attachs[0].src;
        }
      },
      deep: true
    }
  },
  methods: {
    handelOpen: function handelOpen() {
      this.drawer = true;
    },
    handlePictureCardPreview: function handlePictureCardPreview(val) {
      this.srcList.push(val);
      this.isImage = true;
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    },
    // 获取操作记录
    operationRecord: function operationRecord() {
      var _this = this;
      billRecordApi(this.delData.id).then(function (res) {
        _this.recordList = res.data.list;
      });
    },
    handleClose: function handleClose() {
      this.drawer = false;
      this.tabIndex = '1';
      this.imageUrl = '';
    },
    handleClick: function handleClick(e) {
      if (this.tabIndex == '2') {
        this.operationRecord();
      }
    }
  }
};